import React from 'react';

import { formatNumber } from 'utils/formatter';
import * as consts from 'config/consts';
import * as types from 'config/types';

type NumberLabelProps = {
  value: number | null | undefined;
} & Partial<NumberLabelDefaultProps>;
type NumberLabelDefaultProps = {
  unitName: string;
  fraction: number;
  className: string;
  bracketType: types.BracketType;
  numberOfDecimal: number;
  classNames: readonly string[];
  noValueText: string;
  isDispalyNoValueUnit: boolean;
};

const defaultValues: NumberLabelDefaultProps = {
  unitName: '',
  fraction: 0,
  className: '',
  bracketType: consts.BracketType.none,
  numberOfDecimal: 0,
  classNames: ['', ''],
  noValueText: '---',
  isDispalyNoValueUnit: false,
} as const;

const NumberLabel: React.FC<NumberLabelProps> = _props => {
  const props = Object.assign({}, defaultValues, _props);

  const upDownColor =
    !props.value || props.className.match('updown-color-none')
      ? ''
      : props.value > 0
      ? 'text-upcolor'
      : 'text-downcolor';

  // const formattedValue = formatNumber(props.value, {
  //   noValueText: '---',
  //   unitName: props.unitName,
  //   withPlusSign: true,
  //   numberOfDecimal: props.numberOfDecimal,
  // });

  // const decoratedvalue = `${props.bracketType[0]}${formattedValue}${props.bracketType[1]}`;

  // return (
  //   <label className={`${props.className} ${upDownColor}`}>
  //     {decoratedvalue}
  //   </label>
  // );

  const formattedValue = formatNumber(props.value, {
    noValueText: props.noValueText,
    withPlusSign: true,
    numberOfDecimal: props.numberOfDecimal,
  });

  const unitName =
    (props.value === null || props.value === undefined) &&
    !props.isDispalyNoValueUnit
      ? ''
      : props.unitName;

  return (
    <label className={`${props.className} ${upDownColor}`}>
      <div
        className={`flex items-center ${props.classNames[0]}`}
        style={{ whiteSpace: 'nowrap' }}>
        <div>{`${props.bracketType[0]}${formattedValue}`}</div>
        <div className={`${props.classNames[1]}`}>{unitName}</div>
        <div>{props.bracketType[1]}</div>
      </div>
    </label>
  );
};

export default NumberLabel;
